import { render, staticRenderFns } from "./tab-task.vue?vue&type=template&id=61afac62"
import script from "./tab-task.vue?vue&type=script&lang=js"
export * from "./tab-task.vue?vue&type=script&lang=js"
import style0 from "./tab-task.vue?vue&type=style&index=0&id=61afac62&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports